import React from 'react'

import { FluidBox } from 'styled'
import { Root, AnimationBox, DeviceBox, ArrowsBox } from './LandscapeModal.styled.js'

import { ReactComponent as DeviceIcon } from './../../assets/device.svg'
import { ReactComponent as ArrowsIcon } from './../../assets/arrow-rotate.svg'

const LandscapeModal = () => {
  return (
    <Root>
      <AnimationBox>
        <DeviceBox>
          <DeviceIcon></DeviceIcon>
        </DeviceBox>
        <ArrowsBox>
          <ArrowsIcon></ArrowsIcon>
        </ArrowsBox>
      </AnimationBox>
      <FluidBox color="white" maxw={280} lh={1.25}>
        For a better performance of this quiz on mobile, please rotate your device.
      </FluidBox>
    </Root>
  )
}

export default LandscapeModal
